
import { WsSalesSolutionItem, WsSalesSolutionAction } from '../core';
import { isAnyActionSelected } from '../helpers/item-helpers';
import { findActionById } from './sales-actions';
import { getActionEffort, getAreaCssBackgroundColor, getCapabilityEffort } from './sales-items';




const getWidthByString = (s: string) => {

  // BUILD
  // const buildLength = 
  // 5 char = 36px;
  // 7.2px per char

  // Review Intune Infrastructure
  // 28 char = 164px
  // 5.8px per char

  const charWidth = 5.9;

  return s.length * charWidth;
};




const actionHeight = 28;
const actionPadding = 6;




const month = 9; // TODO: remove

const config = {
  waterfall: true,
  monthWidth: 160,
  action: {
    arrowWidth: 12
  }
};




const getTimelineWidth = (maxEffort: number) => {

  const timelineMonths = getTimelineMonths(maxEffort);

  const timelineWidth = 30 + 1 + (timelineMonths.length * config.monthWidth) + 1;

  return timelineWidth;
};




const getTimelineHeight = (items: WsSalesSolutionItem[]) => {

  let height = 30 + 1 + 30;

  items.forEach((item) => {

    if (item.selected) {

      // height of item element (row)
      height = height + 30; 

      // height of actions element (container)
      const itemHeight = getTimelineItemCssHeight(item);

      height = height + itemHeight;
    }

  });

  return height;
};





// transform itemTree to itemList

const getTimelineItems = (items: WsSalesSolutionItem[], isArea: boolean) => {
  const flatItems: WsSalesSolutionItem[] = [];

  items.forEach((item) => {

    if (!isArea) {
      // not area
      if (item.actions && Array.isArray(item.actions) && item.actions.length > 0) {
        // has actions
        flatItems.push(item);
      }
    }

    if (item.items && Array.isArray(item.items) && item.items.length > 0) {
      // has items
      const flatItemChildren = getTimelineItems(item.items, false);
      flatItems.push(...flatItemChildren);
    }

  });

  // return
  return flatItems;
};




const getHoursPerMonth = (month: number) => {
  return 160;
};




const getHourWidth = (month: number) => {

  const hoursPerMonth = getHoursPerMonth(month);

  return config.monthWidth / hoursPerMonth;
};




const getTimelineMonths = (maxEffort: number) => {

  const hoursPerMonth = getHoursPerMonth(month);

  const monthCount = maxEffort / hoursPerMonth;

  const monthList = [ 'M1' ];

  // console.log('getTimelineMonths');
  // console.log(`effort : ${maxEffort}`);
  // console.log(hoursPerMonth);
  // console.log(monthCount);

  // TODO: improvements possibly needed
  while (monthList.length < (monthCount + 1)) {
    monthList.push(`M${(monthList.length + 1)}`);
  }

  return monthList;
};




const getTimelineActionCssBackgroundColor = (areaId: string) => {

  // const x = index % 2;

  // if (x === 1) {
  //   return getAreaCssBackgroundColor(areaId, 1);

  // } else {
  //   return getAreaCssBackgroundColor(areaId, 2);
  // }

  return getAreaCssBackgroundColor(areaId, 2);
};




const getTimelineActionCssTop = (index: number, waterfall: boolean) => {

  if (waterfall) {
    return (index * (actionHeight + actionPadding)) + actionPadding;

  } else {
    return actionPadding;
  }
};




const getTimelineActionCssLeftPosition = (items: WsSalesSolutionItem[], itemActions: WsSalesSolutionAction[], actionId: string) => {
  let leftPosition = 0;

  let currentLeftPosition = 0;

  itemActions.forEach((action: WsSalesSolutionAction, index: number) => {

    if (isAnyActionSelected(action)) {

      // const actionLeftPosition = currentLeftPosition;



      let dependencyMaxLeftPosition = 0;

      action.dependencyIds.forEach((dependencyId: string) => {

        const findAction = findActionById(items, undefined, dependencyId, '', { filterSelected: true, includeChildActions: true });

        if (findAction && findAction.item && findAction.item.actions) {
          // console.log('findAction');
          // console.log(findAction);

          const dependencyLeft = getTimelineActionCssLeftPosition(items, findAction.item.actions, findAction.action.id);

          let dependencyWidth = getTimelineActionWidth(findAction.action);

          // parallel
          const parallel = findAction.action.parallel > 0 ? findAction.action.parallel : 1;
          dependencyWidth = dependencyWidth / parallel;

          // console.log(`left : ${dependencyLeft}`);
          // console.log(`left : ${dependencyWidth}`);

          const dependencyLeftPosition = dependencyLeft + dependencyWidth;

          if (dependencyLeftPosition > dependencyMaxLeftPosition) {
            dependencyMaxLeftPosition = dependencyLeftPosition;
          }
        }

      });



      // console.log();
      if (currentLeftPosition < dependencyMaxLeftPosition) {
        currentLeftPosition = dependencyMaxLeftPosition;
      }



      if (action.id === actionId) {
        // leftPosition += actionLeftPosition
        // leftPosition = cssLeft + dependencyLeftPosition;
        leftPosition = currentLeftPosition;
      }



      let effortWidth = getTimelineActionWidth(action);

      // parallel
      const parallel = action.parallel > 0 ? action.parallel : 1;
      effortWidth = effortWidth / parallel;
      



      //
      currentLeftPosition += effortWidth;
    }

  });

  return leftPosition;
};









const getTimelineActionWidth = (action: WsSalesSolutionAction) => {

  const hourWidth = getHourWidth(month);

  const effort = getActionEffort(action, { includeChildActions: true });

  let effortWidth = effort * hourWidth;



  // const effortInDays = effort / daysPerWeek;

  // const start = today.add(currentHours, 'hours');

  // const end = start.clone().add(effortInDays, 'days');

  // const diff = moment.duration(end.diff(start)).asHours();


  // console.log(`action : ${action.name}`);
  // console.log(`hour   : ${hourWidth}`);
  // console.log(`effort : ${effort}`);
  // console.log(`width  : ${effortWidth}`);
  // console.log(start.toDate());
  // console.log(end.toDate());
  // console.log(diff);



  // parallel

  // const parallel = action.parallel > 0 ? action.parallel : 1;
  // effortWidth = effortWidth / parallel;



  // return
  return effortWidth;
};














const getTimelineItemCssHeight = (item: WsSalesSolutionItem) => {

  if (item.actions && Array.isArray(item.actions) && item.actions.length > 0) {

    let actionsLength: number = 0;

    item.actions.forEach((action) => {

      if (isAnyActionSelected(action)) {

        const parallel = action.parallel > 0 ? action.parallel : 1;

        [ ...Array(parallel) ].forEach((value: any, index: number) => {
          actionsLength = actionsLength + 1;
        });
      }
    });

    // return (item.actions.length * (actionHeight + actionPadding)) + actionPadding;
    return (actionsLength * (actionHeight + actionPadding)) + actionPadding;

  } else {
    // TODO: empty items will need to render something different
    return actionHeight;
  }
};




const getHoursPerDay = () => {
  return 8;
};




export {
  config as timelineConfig,

  getTimelineWidth,
  getTimelineHeight,

  getTimelineItems,
  getTimelineMonths,

  getWidthByString,
  getHoursPerMonth,
  getHourWidth,

  getTimelineActionCssBackgroundColor,
  getTimelineActionCssTop,

  getTimelineActionCssLeftPosition,
  getTimelineActionWidth,

  getTimelineItemCssHeight,

  getHoursPerDay
};
